// @import_dependencies_node Import libraries
import { store } from 'app_storage/redux-storage'
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import { IUser, IUserHttpResponse } from 'app_types/userTypes'
import { IParamsListUsers } from 'app_types/admin/user/userTypes'
// @end

class UserService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil
  private user: any
  private authObj: any
  private i18nUtil: I18nUtil

  constructor() {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
    this.token = this.storeObject.getState().auth?.user?.token
    this.user = this.storeObject.getState().auth.user
    this.authObj = this.storeObject.getState().auth
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Metodo que permite validar si un usuario tiene permiso a un permiso dentro de un modulo
   * @param action Accion que se desea validar
   * @param moduleName Modulo que contiene la accion
   * @returns
   */
  can(action: string, moduleName: string) {
    const user = this.getUserState()

    if (user?.data?.permissions) {
      if (
        user?.data?.permissions[moduleName] !== undefined &&
        user?.data?.permissions[moduleName]?.includes(action)
      ) {
        return true
      }
    }

    return false
  }

  /**
   * Metodo que permite validar si un usuario tiene acceso a un modulo
   * @param moduleName Modulo que se desea validar
   * @returns
   */
  canAccess(moduleName: string) {

    const user = this.getUserState()

    if (user?.data?.permissions) {
      if (user?.data?.permissions[moduleName] !== undefined) {
        return true
      }
    }

    return false
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  // changeScreenMode = async (mode: string) => {
  //   this.refreshAuthToken()
  //   const user = this.getUserState()
  //   if (user && user.data) {
  //     const queryData: HttpCustomStructure = {
  //       method: 'POST',
  //       url: `/api/user/update/${user.data.id}`,
  //       auth_token: this.token,
  //       params: {
  //         profile: {
  //           screen_mode: mode,
  //         },
  //       },
  //     }

  //     let responseData = await this.getResponseData(queryData)
  //     return responseData
  //   }
  // }

  // getResponseData = async (queryData: HttpCustomStructure) => {
  //   let responseData = await this.Http.send(queryData)
  //   if (responseData.code === 200) {
  //     return responseData
  //   } else {
  //     this.screenNotification.fire(responseData)
  //   }
  //   // return null
  //   return responseData
  // }

  get = async (params: IParamsListUsers = {}) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/user`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return responseData
  }

  getOne = async (userId: string) => {
    this.refreshAuthToken()

    let responseData: IUserHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/user/${userId}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.user
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  insertOrUpdate = async (userData: any, action: string = 'create') => {
    this.refreshAuthToken()

    let responseData: IUserHttpResponse
    const formData = new FormData()

    Object.keys(userData).map((key: string) => {
      if (userData[key] && typeof userData[key] === 'object' && !!userData[key][0]?.name && !!userData[key][0].type) {
        formData.append(key, userData[key][0])
      } else if (typeof userData[key] === 'object' && !(userData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(userData[key]))
      } else {
        formData.append(key, userData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/user/${action}`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.user
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  remove = async (userId: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/user/delete/${userId}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  /**
   * Obtiene el usuario desde el storage
   * @returns
   */
  private getUserState() {

    const state = this.storeObject.getState()
    const user: IUser = state.auth.user

    return user
  }

  /**
   * Metodo que personaliza la internacionalización por usuario
   * @param [auth] Objeto de autenticación
   */
  setI18nCustom = (auth?: any) => {

    let _auth: any = null
    if (auth) {
      _auth = auth
    } else if (this.authObj) {
      _auth = this.authObj.user
    }

    if (_auth) {
      if (_auth.locale && _auth.locale !== '') {
        this.i18nUtil.use(_auth.locale)

        if (_auth.alliance?.i18n_configuration) {
          _auth.alliance?.i18n_configuration
          .filter((i: any) => i.culture.toString() === _auth.locale?.toString())
          .map((i: any) => {
            if (_auth.locale && i.data.frontend) {
              this.i18nUtil.addResourceBundle({lng: _auth.locale, resources: i.data.frontend})
            }
          })
        }
      } else {
        this.i18nUtil.use()
      }
    } else {
      this.i18nUtil.use()
    }

  }

  listTeachers = async (params: any = {}) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/user/list-teachers`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return responseData
  }

  sendEmailConfirmation = async (username: string) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/user/send-email-confirmation`,
      auth_token: this.token,
      params: {
        username: username
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return responseData
  }
}

export default UserService
